require('./dist/qw-date.js');

module.exports = 'qwDateModule';



//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/angularjs-qw-date/index.js
// module id = 247
// module chunks = 0